import { LoginFormData } from "@src/types/UserActivation";

export type AuthFormProps = {
  onSubmit: (data: LoginFormData) => void;
  isLoading: boolean;
  rememberMeChecked: boolean;
  setRememberMeChecked: React.Dispatch<React.SetStateAction<boolean>>;
  username: string;
  setUsername: React.Dispatch<React.SetStateAction<string>>;
  setUsernameFormValue: React.Dispatch<React.SetStateAction<string>>;
  setFormPassword: React.Dispatch<React.SetStateAction<string>>;
};

export type EnterOtpFormProps = {
  onSuccess: (isSuccess: boolean) => void;
  user_id: number;
  email: string;
  password: string;
};

export type OtpFormProps = {
  code: string;
};

export enum sessionPopupEnum {
  SESSION_LIMIT_REACHED = "sessionLimitReached",
  SESSION_REMAIN_ACTIVE = "sessionRemainActive",
  CONFIRM_SESSION_LOGOUT = "confirmSessionLogout",
  CONFIRM_ALL_SESSIONS_LOGOUT = "confirmAllSessionsLogout",
}

export type OtpFormDetails = {
  user_id: number;
  email: string;
  password: string;
  isOtpFormOpened: boolean;
};

export enum MfaEventNames {
  MFA = "mfa",
}

export enum MfaEventTypes {
  VIEW_ENTER_OTP_FORM = "view_enter_otp_form",
  EVENT_ENTER_OTP_EXPIRED = "event_enter_otp_expired",
  EVENT_ENTER_OTP_CODE_VERIFIED = "event_enter_otp_code_verified",
  EVENT_ENTER_OTP_INCORRECT = "event_enter_otp_incorrect",
  CLICK_ENTER_OTP_RESEND_CODE = "click_enter_otp_resend_code",
  CLICK_ACTIVE_SESSIONS_ONE_SESSION_LOGGED_OUT = "click_active_sessions_one_session_logged_out",
  CLICK_ACTIVE_SESSIONS_ALL_SESSIONS_LOGGED_OUT = "click_active_sessions_all_sessions_logged_out",
}

export enum AIEventNames {
  AI_CHAT_WIDGET = "ai_chat_widget",
}

export enum AIEventTypes {
  WIDGET_OPENED = "widget_opened",
  WIDGET_CLOSED = "widget_closed",
  CHAT_CLEARED = "chat_cleared",
  PRODUCT_PREVIEW_CLICKED = "product_preview_clicked",
  SHOW_ALL_RESULTS_CLICKED = "show_all_results_clicked",
  CLASSIC_SEARCH_CLICKED = "classic_search_clicked",
  VDB_AI_SEARCH_CLICKED = "vdb_ai_search_clicked",
}
